module.exports = __webpack_public_path__ + "img/user.01665f8c.jpg";